const typeList = {
    USEROWNEDLIST: 1,
    SOLO: 2,
    ENUM: 3
};

export default typeList;
